import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { ImageOff } from 'lucide-react';
import { getApiUrl } from '../../utils/api';

export const privateRecipeUrl = (url) => url.startsWith('/api/') ? `${getApiUrl()}${url.slice(4)}` : url;

export const PrivateRecipeImage = ({ src, alt, className = '', testId, w, onError }) => {
  const url = w ? `${src}${src.includes('?') ? '&' : '?'}w=${w}` : src; // vignette carrée compressée côté serveur
  const [image, setImage] = useState('');
  const [error, setError] = useState(false);
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const node = ref.current;
    if (!node || visible) return undefined;
    if (typeof IntersectionObserver === 'undefined') { setVisible(true); return undefined; }
    const observer = new IntersectionObserver(entries => { if (entries.some(e => e.isIntersecting)) setVisible(true); }, { rootMargin: '1200px' });
    observer.observe(node);
    return () => observer.disconnect();
  }, [visible]);
  useEffect(() => {
    if (!visible) return undefined;
    let alive = true; let objectUrl;
    setImage(''); setError(false);
    const controller = new AbortController();
    axios.get(privateRecipeUrl(url), { responseType: 'blob', signal: controller.signal }).then(r => {
      if (alive) { objectUrl = URL.createObjectURL(r.data); setImage(objectUrl); }
    }).catch(e => { if (alive && !axios.isCancel(e)) { setError(true); onError?.(); } });
    return () => { alive = false; controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [url, visible]); // eslint-disable-line react-hooks/exhaustive-deps
  return image ? <img className={className} src={image} alt={alt} data-testid={testId} /> : <span ref={ref} className={`${className} menu-image-loading`} role="status" data-testid={`${testId}-${error ? 'error' : 'loading'}`} aria-label={error ? 'Image indisponible' : 'Chargement image'}>{error && <ImageOff size={20} />}</span>;
};
